import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import ProductIconText from '../ProductIconText';
import CtaModal from '../../../CtaModal';
import Pills from '../../../../Core/Pills';

import {
  Block,
  Content,
  ProductTag,
  ImageWrapper,
  Img,
  LegalCopy,
  Header,
  StyledCtas,
  Footer,
} from './styles';

// * ClassName {string} - CSS Class for styling
// * heading {Obj/Richtext} - Richtext node for the card headline
// * description {Obj/Richtext} - Richtext node for the card body copy
// * Icon {Obj} - icon in the top of the card

// * Resolves all BLOCKS into their respected HTML tags
export const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <LegalCopy>{children}</LegalCopy>,
  },
};

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <>{children}</>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data } = node;
      if (data.target.__typename === 'ContentfulTitleOrImageWithIconLists') {
        return <ProductIconText data={data.target} />;
      }
      return null;
    },
  },
};

const FeatureBlock = ({ className = 'white', data }) => {
  if (!data) return null;

  const {
    heading,
    productType,
    imageDam,
    bodyCopy,
    bottomCopy,
    ctas,
    cardClassName,
    subhead,
    pillText,
    pillTextColor,
    pillBackgroundColor,
  } = data;

  const product = productType || cardClassName || '';

  const ctaModals = ctas.filter(cta => cta.internal.type === 'ContentfulModal');
  const ctasFiltered = ctas.filter(
    cta => cta.internal.type !== 'ContentfulModal',
  );

  return (
    <Block className={className}>
      <Header className="heading-container">
        {pillText && (
          <Pills
            backgroundColor={pillBackgroundColor}
            textColor={pillTextColor}
          >
            {pillText}
          </Pills>
        )}
        {imageDam && (
          <ImageWrapper>
            <Img src={imageDam} alt={imageDam.altText || ''} />
          </ImageWrapper>
        )}
        {heading && <RichText document={heading} />}
      </Header>
      {subhead && (
        <ProductTag className={product.toLowerCase().split(' ').join('-')}>
          <RichText document={subhead} />
        </ProductTag>
      )}
      <Content $hasTag={!!subhead}>
        {bodyCopy && <RichText document={bodyCopy} options={body} />}
      </Content>
      {ctas && (
        <Footer>
          {ctaModals &&
            ctaModals.map(modal => {
              return (
                <CtaModal
                  key={modal.id}
                  data={modal}
                  className="product-block"
                />
              );
            })}
          {bottomCopy && <RichText document={bottomCopy} options={options} />}
          <StyledCtas
            ctas={ctasFiltered}
            direction="column"
            alignment="center"
          />
        </Footer>
      )}
    </Block>
  );
};

FeatureBlock.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape().isRequired,
};

export default FeatureBlock;
